export const environment = {
    production: true,
    state: 'production',
    recaptcha: {
        siteKey: '6LcyU2YpAAAAAFFG3PzUtHw_Ft7C1VMUFOhIeGIn',
    },
};
